import { render } from "./AppUpdateScreen.vue?vue&type=template&id=a7f9acaa&scoped=true"
import script from "./AppUpdateScreen.vue?vue&type=script&lang=js"
export * from "./AppUpdateScreen.vue?vue&type=script&lang=js"

import "./AppUpdateScreen.vue?vue&type=style&index=0&id=a7f9acaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7f9acaa"]])

export default __exports__